module.exports = __webpack_public_path__ + "img/3.a6388d7f.jpg";